import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';
import { useSportContext } from '@sorare/core/src/contexts/sport';

/**
 * Force the behavior in My Cards where a rarity is selected by default, even on desktop viewport.
 * This is used for football common game features (e.g. dropping) and for MLB for sealing & vault.
 */
export const useForceMyCardsTabs = () => {
  const { currentUser } = useCurrentUserContext();
  const { sport } = useSportContext();
  return (
    (sport === Sport.FOOTBALL &&
      !!currentUser?.betaTesterFootballCommonCardsGame) ||
    sport === Sport.BASEBALL
  );
};
